"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listPropertyRecaptureApiToken = exports.listPropertyApiToken = exports.ListPropertySellStatus = exports.ListPropertyFeatureApi = exports.ListPropertyType = exports.ListPropertyRentAvailability = void 0;
var Api_1 = require("@/api/remote/Api");
var ListPropertyRentAvailability;
(function (ListPropertyRentAvailability) {
    ListPropertyRentAvailability[ListPropertyRentAvailability["Immediately"] = 1] = "Immediately";
    ListPropertyRentAvailability[ListPropertyRentAvailability["SelectDate"] = 2] = "SelectDate";
})(ListPropertyRentAvailability = exports.ListPropertyRentAvailability || (exports.ListPropertyRentAvailability = {}));
var ListPropertyType;
(function (ListPropertyType) {
    ListPropertyType[ListPropertyType["SALE"] = 1] = "SALE";
    ListPropertyType[ListPropertyType["RENT"] = 2] = "RENT";
})(ListPropertyType = exports.ListPropertyType || (exports.ListPropertyType = {}));
var ListPropertyFeatureApi;
(function (ListPropertyFeatureApi) {
    ListPropertyFeatureApi[ListPropertyFeatureApi["Balcony"] = 1] = "Balcony";
    ListPropertyFeatureApi[ListPropertyFeatureApi["Terrace"] = 2] = "Terrace";
    ListPropertyFeatureApi[ListPropertyFeatureApi["Rooftop"] = 3] = "Rooftop";
    ListPropertyFeatureApi[ListPropertyFeatureApi["Garden"] = 4] = "Garden";
    ListPropertyFeatureApi[ListPropertyFeatureApi["MaidsRoom"] = 5] = "MaidsRoom";
    ListPropertyFeatureApi[ListPropertyFeatureApi["CarPark"] = 6] = "CarPark";
    ListPropertyFeatureApi[ListPropertyFeatureApi["PrivatePool"] = 7] = "PrivatePool";
})(ListPropertyFeatureApi = exports.ListPropertyFeatureApi || (exports.ListPropertyFeatureApi = {}));
var ListPropertySellStatus;
(function (ListPropertySellStatus) {
    ListPropertySellStatus[ListPropertySellStatus["Vacant"] = 1] = "Vacant";
    ListPropertySellStatus[ListPropertySellStatus["Occupied"] = 2] = "Occupied";
    ListPropertySellStatus[ListPropertySellStatus["Tenanted"] = 3] = "Tenanted";
})(ListPropertySellStatus = exports.ListPropertySellStatus || (exports.ListPropertySellStatus = {}));
exports.listPropertyApiToken = function (form, languageCode, token) { return Api_1.api().request({
    method: 'POST',
    url: languageCode + "/api/communication/listproperty",
    headers: {
        'X-XSRF-TOKEN': token,
    },
    data: form,
}); };
exports.listPropertyRecaptureApiToken = function (form, languageCode, token) { return Api_1.api().request({
    method: 'POST',
    url: languageCode + "/api/communication/submitrecapturedcontact",
    headers: {
        'X-XSRF-TOKEN': token,
    },
    data: form,
}); };
